import clsx from 'clsx'

import FormSignUpContent from './components/FormSignUpContent/FormSignUpContent'
import { IFormSignUpProps } from './types'
import useFormSignUp from './useFormSignUp'

const FormSignUp = ({ onSuccess, type, ...rest }: IFormSignUpProps) => {
  const {
    hasAction,
    accType,
    isLoading,
    error,
    submittionCount,
    changeTab,
    onSubmit,
    recaptchaContainer,
    showReCaptcha
  } = useFormSignUp({
    onSuccess,
    type
  })

  return (
    <div className="relative">
      <FormSignUpContent
        {...rest}
        className={clsx(showReCaptcha && 'blur')}
        hasAction={hasAction}
        accType={accType}
        isLoading={isLoading}
        error={error}
        changeTab={changeTab}
        onSubmit={onSubmit}
      />

      <div
        className={clsx(
          'absolute top-0 left-0 z-10 h-full w-full',
          !showReCaptcha && 'pointer-events-none'
        )}
      >
        <div
          key={`${submittionCount}`}
          className={clsx(
            'absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] ',
            !showReCaptcha && ' invisible'
          )}
          ref={recaptchaContainer}
        ></div>
      </div>
    </div>
  )
}

export default FormSignUp
